import { useEffect, useRef, useState } from "react";

import moment from "moment";

const RELOAD_INTERVAL = 15_000;

export const useTimeAgo = () => {
  const dateRef = useRef(moment());
  const [diff, setDiff] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();

      const diff = dateRef.current.diff(now);

      setDiff(diff);
    }, RELOAD_INTERVAL);

    return () => {
      clearInterval(interval);
    };
  }, [setDiff]);

  const resetCount = () => {
    dateRef.current = moment();
    setDiff(0);
  };

  const timeAgoString = moment.duration(diff).humanize(true);

  return [timeAgoString, resetCount] as const;
};
